import type { Control, FieldValues, Path } from 'react-hook-form';
import { CharacterCounter } from '@/components/common/CharacterCounter';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { PCMP_EDIT_LIMITS } from '../../constants/pcmpProposal.constants';

interface PcmpEditReasonFieldProps<T extends FieldValues & { reason: string }> {
  control: Control<T>;
}

/** Required on every edit; the API records it on the proposal's timeline. */
export function PcmpEditReasonField<T extends FieldValues & { reason: string }>({
  control,
}: PcmpEditReasonFieldProps<T>) {
  return (
    <FormField
      control={control}
      name={'reason' as Path<T>}
      render={({ field }) => (
        <FormItem>
          <div className="flex items-center justify-between gap-2">
            <FormLabel>
              Reason <span className="text-destructive">*</span>
            </FormLabel>
            <CharacterCounter
              current={String(field.value ?? '').length}
              max={PCMP_EDIT_LIMITS.reason}
            />
          </div>
          <FormControl>
            <Textarea
              {...field}
              rows={3}
              maxLength={PCMP_EDIT_LIMITS.reason}
              placeholder="Why is this being changed?"
            />
          </FormControl>
          <FormDescription>Shown on the proposal&apos;s timeline.</FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
